<ng-scrollbar style="height: calc(100vh - 88px)" visibility="hover" orientation="vertical" [dir]="direction">
  @if (showContent) {
    <app-card [showHeader]="false" cardClass="user-card" padding="20">
      <div class="flex align-item-center">
        <div class="flex-shrink-0">
          <img [src]="avatarUrl" alt="user-image" class="user-avatar" />
        </div>
        <div class="flex-grow-1 user-details">
          <div class="f-w-600">{{ this.authenticationService.currentUserName }}</div>
          <div class="mat-caption">{{ this.razonSocial }}</div>
          <div class="f-w-600" *ngIf="this.roleUsuario">{{ this.roleUsuario }}</div>
        </div>
        <div class="user-setting">
          <a href="javascript:" [matMenuTriggerFor]="menu" class="text-muted">
            <svg class="pc-icon">
              <use xlink:href="assets/fonts/custom-icon.svg#custom-sort-outline"></use>
            </svg>
          </a>
          <mat-menu #menu="matMenu" [overlapTrigger]="false" yPosition="below" xPosition="after">
            <button mat-menu-item>
              <a [routerLink]="['/application/profile/account']" class="text-muted" style="text-decoration: none">
                <i class="ti ti-user f-18 m-r-10"></i>
                <span>Mi cuenta</span>
              </a>
            </button>
            <!-- <button mat-menu-item>
              <a href="javascript:" class="text-muted" [routerLink]="['/application/profile/account/settings']">
                <i class="ti ti-settings f-18 m-r-10"></i>
                <span>Settings</span>
              </a>
            </button> -->
            <!-- <button mat-menu-item>
              <a href="javascript:" class="text-muted" [routerLink]="['/application/profile/account/settings']">
                <i class="ti ti-lock f-18 m-r-10"></i>
                <span>Lock Screen</span>
              </a>
            </button> -->
            <button mat-menu-item>
              <a href="javascript:" class="text-muted" (click)="logout()" style="text-decoration: none">
                <i class="ti ti-power f-18 m-r-10"></i>
                <span>Salir</span>
              </a>
            </button>
          </mat-menu>
        </div>
      </div>
    </app-card>
  }
  <div class="navbar-content" style="background-color: #02294c !important">
    <ul class="nav coded-inner-navbar" (click)="fireOutClick()">
      @for (item of menus(); track item) {
        @if (item.type === 'group') {
          <app-menu-group-vertical [item]="item" />
        } @else if (item.type === 'item') {
          <app-menu-item [item]="item" />
        } @else if (item.type === 'collapse') {
          <app-menu-collapse [item]="item" />
        }
      }
    </ul>
  </div>
</ng-scrollbar>
